module.exports = [{
      plugin: require('/var/lib/jenkins/workspace/one_commercial/one-commercial/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/var/lib/jenkins/workspace/one_commercial/one-commercial/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
